import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { Icon as Icon$1 } from '@cheetahdigital/console-kit-cx';
import styles from './index.module.scss.js';

var Icon = function (_a) {
    var name = _a.name, _b = _a.color, color = _b === void 0 ? "accent" : _b, _c = _a.size, size = _c === void 0 ? "small" : _c, isSolid = _a.isSolid, isCircular = _a.isCircular;
    return (jsx("span", __assign({ className: styles.icon }, { children: jsx(Icon$1, { name: name, color: color, size: size, isSolid: isSolid, isCircular: isCircular }, void 0) }), void 0));
};

export { Icon as default };
